import { Money } from "classes/DecimalClasses";

import { FrmTextField } from "components/formFields/FrmTextField";
import { HoverHelp } from "components/utility/HoverHelp";

import { checkForUnexpectedProps } from "services/utility/misc";

export function FrmTextFieldWithHoverHelp(props) {
  const {
    label,
    onValueBlur,
    onValueChange,
    value,
    error,
    name,
    number,
    sx,
    startAdornment,
    helpText,
    autoFocus,
    disabled,
    money,
    dataTesting,
    maxLength,
    endAdornment,
    minWidth,
    ...unexpected
  } = props;
  checkForUnexpectedProps("FrmTextFieldWithHoverHelp", unexpected);

  function handleBlur(name, value) {
    onValueBlur(name, money ? new Money(value || 0) : value);
  }

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <FrmTextField
        label={label}
        onValueBlur={handleBlur}
        onValueChange={onValueChange}
        value={value}
        error={error}
        name={name}
        number={number}
        startAdornment={startAdornment}
        autoFocus={autoFocus}
        disabled={disabled}
        sx={sx}
        money={money}
        maxLength={maxLength}
        minWidth={minWidth}
        dataTesting={dataTesting}
        endAdornment={endAdornment}
      />
      <HoverHelp title={helpText} sx={{ marginTop: "0.3em" }} />
    </div>
  );
}
